import React from 'react';
import {styled} from '@netx/core-components/Theme';
import {useIsCustomActionEndpointUrlAccessible} from '../../hooks/useIsCustomActionEndpointUrlAccessible';
import {
	CUSTOM_ACTION_COLUMN_LABEL,
	CUSTOM_ACTION_LABEL,
	CUSTOM_ACTION_MESSAGE,
} from '../../locales';
import {CustomActionField} from '../../schema';
import {
	CustomActionEndpoint,
	CustomActionEndpointProps,
} from '../CustomActionEndpoint';

const CustomActionEndpointPayloadUrlRoot = styled(CustomActionEndpoint)(
	({theme}) => ({}),
);

export interface CustomActionEndpointPayloadUrlProps
	extends CustomActionEndpointProps {}

export const CustomActionEndpointPayloadUrlPrimitive = ({
	changed,
	customActionId,
	...props
}: CustomActionEndpointPayloadUrlProps) => {
	const {check, checking, valid} = useIsCustomActionEndpointUrlAccessible({
		id: customActionId,
	});

	return (
		<CustomActionEndpointPayloadUrlRoot
			label={CUSTOM_ACTION_COLUMN_LABEL[CustomActionField.payloadUrl]}
			name={CustomActionField.payloadUrl}
			required
			{...props}
			// for checking endpoint accessibility
			testButtonLabel={CUSTOM_ACTION_LABEL.TEST_ENDPOINT_URL}
			testingURL={checking}
			testingUrlMessage={CUSTOM_ACTION_MESSAGE.CHECKING_ENDPOINT}
			urlAccessible={valid}
			urlAccessibleMessage={CUSTOM_ACTION_MESSAGE.ENDPOINT_ACCESSIBLE}
			urlInaccessibleMessage={CUSTOM_ACTION_MESSAGE.ENDPOINT_INACCESSIBLE}
			onTestURL={!changed && customActionId != null ? check : undefined}
		/>
	);
};

export const CustomActionEndpointPayloadUrl =
	CustomActionEndpointPayloadUrlPrimitive;

export default CustomActionEndpointPayloadUrl;
